import axios from "axios";
import { Toast } from 'vant';
import Cookies from 'js-cookie'
import { getAppID, isToufang, getUserInfo, setUserInfo } from "@/utils/base";
import { isAndroid } from '@/utils/tools'
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from "@/utils/constant";
import { getStorage } from '@/utils/tools'
import { fetchReportEvent } from './index'

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  if(config.url !== '/api/v1/user/tmp_register'){
     if(!Cookies.get(USER_ID_COOKIES_KEY) || !Cookies.get(USER_TOKEN_COOKIES_KEY) || !getStorage(USER_ID_COOKIES_KEY) || !getStorage(USER_TOKEN_COOKIES_KEY)){
      console.log('请求前检查cookies失败，重新设置', config.url)
      const user_id = window?.[USER_ID_COOKIES_KEY];
      const user_token = window?.[USER_TOKEN_COOKIES_KEY];
      setUserInfo(user_id, user_token)
      fetchReportEvent({
        type: 'log',
        position: 'no_catch',
        ext: JSON.stringify({
          api_url: config.url,
          user_id: window?.[USER_ID_COOKIES_KEY] || 'null',
        })
      })
    }
  }
  
  // 在发送请求之前做些什么
  config.data = {
    ...config.data || {},
    is_debug: 1,
    app_id: getAppID()
  }
  if(getUserInfo().user_token){
    config.headers.Authorization = `Bearer ${getUserInfo().user_token}`
  }
  config.headers.device = 'h5'
  config.headers.H5device = isAndroid() ? 'android' : 'ios'
  if(isToufang()){
    config.headers.Adfrom = 1
  }
  if(config.isToast !== false){
    Toast.loading({
      duration: 0,
    });
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  if(response.config.isClearToast !== 'none'){
    Toast.clear();
  }
  return response;
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  const errData = typeof error.response?.data === 'string'? JSON.parse(error.response?.data) : error.response?.data
  if(errData?.code !== 0){
    Toast({
      message: errData?.msg || 'Error',
    })
  }
  setTimeout(() => {
    Toast.clear();
  }, 1000);
  return Promise.reject(error);
});

export const request = function(options = {}){
  return new Promise((resolve, reject) => {
    axios.request({
      ...config,
      ...options
    }).then(res => {
      if(options.responseType === 'all'){
        resolve(JSON.parse(res.data))
        return
      }
      resolve(res.data.data)
    }).catch(err => {
      reject(err)
    })
  })
}
